import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactAnimation extends EventRegistryCategory {
    label = 'Animation Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    animationstart = () => new EventRegistryItem({ handlerName: 'onAnimationStart' });
    animationend = () => new EventRegistryItem({ handlerName: 'onAnimationEnd' });
    animationiteration = () => new EventRegistryItem({ handlerName: 'onAnimationIteration' });
}
